export default "__VITE_ASSET__C0M1OZLy__"